import { render, staticRenderFns } from "./HealthcareProvider.vue?vue&type=template&id=74dd0b1b"
import script from "./HealthcareProvider.vue?vue&type=script&lang=js"
export * from "./HealthcareProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports